<template>
    <div class="container-fluid content-wrapper">
        <b-row class="content-heading">
            <b-col>
                <div>Variant Sort Order</div>
            </b-col>
            <b-col cols="auto" class="ms-auto">
                <p-button variant="primary" type="button" :is-busy="isBusy" @click="save">Save</p-button>
            </b-col>
        </b-row>

        <b-row class="mb-3">
            <b-col>
                <p-button variant="secondary" type="button" @click="backToVariants">Back to Variants</p-button>
            </b-col>
        </b-row>

        <p-card>
            <b-row class="px-2 pb-2">
                <b-col>
                    Drag the <b-icon-arrow-down-up /> up and down to change the variant sort order.  Click save to persist the changes.  The sort order is used when displaying variants in lists and sortable grids.
                </b-col>
            </b-row>
            <b-row class="sort-order-header fw-bold px-2 py-2">
                <b-col cols="auto" class="handle-col"></b-col>
                <b-col>Variant Name</b-col>
                <b-col>Category</b-col>
                <b-col cols="3">Status</b-col>
            </b-row>
            <!--
                Auto-scroll while dragging is provided by SortableJS's bundled AutoScroll
                plugin (options passed through vuedraggable as attributes). force-fallback
                switches off native HTML5 drag so auto-scroll works against the window as the
                user drags a row toward the top/bottom of a list taller than the viewport.
            -->
            <draggable
                v-model="items"
                item-key="productVariantId"
                handle=".sort-order-row"
                class="sort-order-list"
                :force-fallback="true"
                :fallback-on-body="true"
                :scroll="true"
                :scroll-sensitivity="120"
                :scroll-speed="64"
                @change="markDirty">
                <template #item="{ element }">
                    <b-row class="sort-order-row align-items-center px-2 py-2">
                        <b-col cols="auto" class="handle-col">
                            <span class="drag-handle" title="Drag to reorder"><b-icon-arrow-down-up /></span>
                        </b-col>
                        <b-col>{{ element.variantName }}</b-col>
                        <b-col>{{ element.category }}</b-col>
                        <b-col cols="3">{{ element.status }}</b-col>
                    </b-row>
                </template>
            </draggable>
        </p-card>

        <b-row class="mt-3">
            <b-col class="text-end">
                <p-button variant="primary" type="button" :is-busy="isBusy" @click="save">Save</p-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import NavigationGuard from '@/components/mixins/NavigationGuard.js';
import draggable from 'vuedraggable';
import axios from 'axios';

export default {
    mixins: [NavigationGuard],
    components: { draggable },
    data() {
        return {
            isBusy: false,
            items: []
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            axios.get('productvariant/sortorder').then(resp => {
                this.items = resp.data;
                this.dataLoaded();
            });
        },
        markDirty() {
            this.formIsDirty = true;
        },
        backToVariants() {
            this.$router.push('/productvariants');
        },
        save() {
            this.isBusy = true;
            axios
                .post('productvariant/sortorder', {
                    productVariantIds: this.items.map(x => x.productVariantId)
                })
                .then(() => {
                    this.dataSaved();
                    this.$appSuccess('Variant sort order saved successfully.');
                    // Reload so the list reflects the canonical saved order.
                    this.loadData();
                })
                .finally(() => {
                    this.isBusy = false;
                });
        }
    }
};
</script>

<style scoped lang="scss">
@import '@/styles/app/common/variables.scss';
.sort-order-header {
    border-bottom: 2px solid $gray-light;
}
.sort-order-row {
    border-bottom: 1px solid $gray-lighter;
    background-color: white;
    // Whole row is the drag handle.
    cursor: grab;
    // Prevent the browser from text-selecting rows as they're dragged past the pointer.
    user-select: none;
}
.sort-order-row:active {
    cursor: grabbing;
}
.sort-order-row:hover {
    background-color: $gray-lighter;
}
.handle-col {
    width: 40px;
}
.drag-handle {
    color: $text-muted;
    font-size: 1.1rem;
}
.sort-order-row:hover .drag-handle {
    color: $gray-dark;
}
.sortable-ghost {
    opacity: 0.5;
    background-color: $gray-light;
}
</style>
